import { debounce, throttleRaf } from '../../util/helpers';

export default {
  init() {
    const main = document.querySelector('main');
    const backgroundPatterns = document.querySelectorAll('.background-pattern');

    // switch to regular page background pattern when salt conversion page
    if (document.body.classList.contains('single-article') && main.querySelector('.ms-conversion-table')) {
      document.body.classList.add('override-background-pattern');
      document.body.classList.add('regular-page');
    }

    const hero = main.querySelector(['.ms-small-hero .ms-small-hero__bg-image', '.ms-article-hero .ms-article-hero__bg-image', '.ms-category-hero .ms-category-hero__hero', '.ms-product-detail-hero .ms-product-detail-hero__container']);
    let scrollFactor = {
      'pattern-A': -15,
      'pattern-B': -10,
    };

    const resizeListener = debounce(() => {
      // mutate scroll factor
      if (document.body.classList.contains('home') && window.innerWidth >= 1280) {
        scrollFactor = {
          'pattern-A': -25,
          'pattern-B': -10,
        };
      } else {
        scrollFactor = {
          'pattern-A': -15,
          'pattern-B': -10,
        };
      }
      // add background pattern height for the offset animation
      backgroundPatterns.forEach(backgroundPattern => {
        const backgroundScrollFactor = scrollFactor[backgroundPattern.dataset.variant];
        const offsetHeight = document.body.clientHeight * Math.abs(backgroundScrollFactor / 100);
        // to do: remove additional 300 offset, offsetHeight should be enough
        backgroundPattern.style.height = `calc(100% + ${offsetHeight + 300}px)`
      });

      // reposition background pattern if has hero
      if (hero) {
        const heroHeight = hero.clientHeight;
        backgroundPatterns.forEach(backgroundPattern => {
          backgroundPattern.style.top = `${heroHeight}px`;
        });
      }
    }, 500);
    resizeListener();

    window.addEventListener('resize', resizeListener);
    const removeResizeListener = () => window.removeEventListener('resize', resizeListener);

    const scrollListener = throttleRaf(() => {
      backgroundPatterns.forEach(backgroundPattern => {
        const backgroundScrollFactor = scrollFactor[backgroundPattern.dataset.variant];
        const backgroundOffset = ((window.scrollY || window.pageYOffset) / (document.body.clientHeight - window.innerHeight)) * backgroundScrollFactor;
        backgroundPattern.style.transform = `translateY(${backgroundOffset}%) translateX(-50%)`;
      });
    });

    window.addEventListener('scroll', scrollListener);
    const removeScrollListener = () => window.removeEventListener('scroll', scrollListener);

    window.addEventListener('beforeunload', () => {
      removeResizeListener();
      removeScrollListener();
    });
  },
  finalize() {
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/backgroundPattern.js